export const defaultJson = [
  {
    stepId: 'profileDetails',
    stepName: 'Personal Information',
    showStepName: false,
    stepVisible: true,
    stepPosition: 0,
    stepType: 'form',
    sections: [
      {
        apiKeyId: 'application',
        sectionId: 'instructions',
        sectionName: 'Personal Information',
        subSectionName: '',
        sectionPosition: 1,
        sectionHelp: 'Fields marked with * are required',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[ProgramName__c]',
            required: true,
            name: 'application[ProgramName__c]',
            label: 'Program',
            type: 'input',
            disabled: true,
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Applying_as__c]',
            required: true,
            name: 'application[Applying_as__c]',
            label: 'Applying as',
            type: 'input',
            disabled: true,
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Salutation]',
            required: true,
            name: 'applicant[Salutation]',
            label: 'Salutation',
            type: 'select',
            options: [
              { label: 'Mr.', value: 'Mr.' },
              { label: 'Ms.', value: 'Ms.' },
              { label: 'Mrs.', value: 'Mrs.' },
              { label: 'Dr.', value: 'Dr.' },
              { label: 'Miss.', value: 'Miss.' }
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[FirstName]',
            required: true,
            name: 'applicant[FirstName]',
            label: 'First Name',
            type: 'input',
            disabled: true,
            validationType: 'alphaWithSpace',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid First Name',
              },
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[LastName]',
            required: true,
            name: 'applicant[LastName]',
            label: 'Last Name',
            type: 'input',
            disabled: true,
            validationType: 'lastName',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid Last Name',
              },
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Preferred_Full_Name__c]',
            required: true,
            name: 'applicant[Preferred_Full_Name__c]',
            label: 'Preferred Full Name (for Certificate)',
            type: 'input',
            validationType: 'fullName',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid full name',
              },
              maxLength: {
                value: 255,
                message: 'This field cannot be more than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Birthdate]',
            required: true,
            name: 'applicant[Birthdate]',
            label: 'Date Of Birth',
            type: 'date',
            format: 'YYYY-MM-DD',
            maxDate: true,
            validations: {
              required: 'This field is required',
            },
            disableKeyDown: true,
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[hed__Gender__c]',
            required: true,
            name: 'applicant[hed__Gender__c]',
            label: 'Gender',
            type: 'select',
            options: [
              { label: 'Male', value: 'Male' },
              { label: 'Female', value: 'Female' },
              { label: 'Others', value: 'Others' }
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[hed__Citizenship__c]',
            required: true,
            name: 'applicant[hed__Citizenship__c]',
            label: 'Nationality',
            type: 'select',
            metaData: {
              optionsKey: 'nationality'
            },
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Nationality_Others__c]',
            required: true,
            name: 'applicant[Nationality_Others__c]',
            label: 'Please Specify Nationality',
            type: 'input',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'applicant[hed__Citizenship__c]',
                expectedValue: 'Others',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Professional_Profile_URL__c]',
            required: false,
            name: 'application[Professional_Profile_URL__c]',
            label: 'Professional Profile URL (Optional)',
            type: 'input',
            validationType: 'url',
            validations: {
              pattern: {
                value: '',
                message: 'Please enter a valid URL',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'applicant',
        sectionId: 'contact',
        sectionName: 'Contact Information',
        subSectionName: '',
        sectionPosition: 2,
        sectionHelp: 'Fields marked with * are required',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'applicant[Email]',
            required: true,
            name: 'applicant[Email]',
            label: 'Email ID',
            type: 'input',
            disabled: true,
            validationType: 'email',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Accept correct gmail address',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Phone]',
            name: 'applicant[Phone]',
            label: 'Mobile number',
            type: 'input',
            disabled: true,
            required: true,
            validationType: 'number',
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[0-9]+$/,
                message: 'Accept only numbers',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Whatsapp_No__c]',
            name: 'applicant[Whatsapp_No__c]',
            label: 'Whatsapp No (Optional)',
            type: 'input',
            required: false,
            validationType: 'phone',
            validations: {
              pattern: {
                value: /^[+0-9]+$/,
                message: 'Accept only numbers and + symbol',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'addresses',
        sectionId: 'address',
        sectionName: 'Communication Address',
        sectionNameHelperLabel: 'This address will be used for future communications',
        subSectionName: '',
        sectionPosition: 3,
        sectionHelp: 'Fields marked with * are required',
        sectionType: 'form',
        fields: [
          {
            name: 'addresses[0]',
            type: 'address',
            options: [
              {
                fieldId: 'hed__MailingCountry__c',
                required: true,
                name: 'hed__MailingCountry__c',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'hed__MailingState__c',
                required: true,
                name: 'hed__MailingState__c',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'hed__MailingCity__c',
                required: true,
                name: 'hed__MailingCity__c',
                label: 'City',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
            ],
          },
          {
            fieldId: 'addresses[0][hed__MailingStreet__c]',
            required: true,
            name: 'addresses[0][hed__MailingStreet__c]',
            label: 'Address Line 1',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 254,
                message: 'This field cannot be more than 254 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[0][hed__MailingStreet2__c]',
            required: true,
            name: 'addresses[0][hed__MailingStreet2__c]',
            label: 'Address Line 2',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 254,
                message: 'This field cannot be more than 254 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[0][hed__MailingPostalCode__c]',
            required: true,
            name: 'addresses[0][hed__MailingPostalCode__c]',
            label: 'Pincode',
            type: 'input',
            validationType: 'number',
            validations: {
              required: 'This field is required',
              "minLength": {
                "value": 6,
                "message": "Please enter a valid Zipcode"
              },
              "maxLength": {
                "value": 6,
                "message": "Please enter a valid Zipcode"
              },
              "pattern": {
                "value": "",
                "message": "Please enter a valid Zipcode"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "addresses[0][hed__MailingCountry__c]",
                "expectedValue": "India",
                "type": "LEAF"
              }
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[0][hed__MailingPostalCode__c]',
            required: true,
            name: 'addresses[0][hed__MailingPostalCode__c]',
            label: 'Pincode',
            type: 'input',
            validationType: 'alphaNumeric',
            validations: {
              required: 'This field is required',
              "minLength": {
                "value": 6,
                "message": "This field cannot be less than 6 characters"
              },
              "maxLength": {
                "value": 15,
                "message": "This field cannot be more than 15 characters"
              },
              "pattern": {
                "value": "",
                "message": "Please enter a valid Zipcode"
              }
            },
            "rule": {
              "effect": "HIDE",
              "condition": {
                "scope": "addresses[0][hed__MailingCountry__c]",
                "expectedValue": "India",
                "type": "LEAF"
              }
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'academicDetails',
    stepName: 'Academic Background',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'form',
    sections: [
      {
        sectionId: 'academicBackground',
        sectionName: 'Academic Information',
        subSectionName: '',
        summarySection: 'Academic Information',
        sectionPosition: 5,
        sectionHelp: 'Fields marked with * are required',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'academicRecords',
            name: 'academicRecords',
            label: 'Academic Records',
            type: 'array',
            buttonConfigs: {
              text: 'Add More +',
            },
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 10,
              removeMultiple: true,
              name: 'academicRecords',
              dynamicTitle: 'Academic Record',
            },
            fieldsArray: [
              {
                fieldId: 'degree_type_frontend',
                required: true,
                name: 'degree_type_frontend',
                label: 'Education Level',
                type: 'select',
                metaData: {
                  optionsKey: 'educationLevel',
                  triggerClearFields: true, // Flag to indicate this field should trigger clearing dependent fields
                },
                options: [
                  { label: 'Diploma', value: 'Diploma' },
                  { label: 'Bachelor', value: 'Bachelor' },
                  { label: 'Masters Degree', value: 'Masters Degree' },
                  { label: 'Doctoral Degree', value: 'Doctoral Degree' },
                  { label: 'Professional Degree (CA/CS/ICWA)', value: 'Professional Degree (CA/CS/ICWA)' },
                  { label: 'Others', value: 'Others' }
                ],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'degree_level_others_frontend',
                required: true,
                name: 'degree_level_others_frontend',
                label: 'Education Level Others',
                type: 'input',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'degree_type_frontend',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 255,
                    message: 'This field cannot be more than 255 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'degree_name_frontend',
                required: true,
                name: 'degree_name_frontend',
                label: 'Degree Name',
                type: 'select',
                metaData: {
                  optionsKey: 'degreeName',
                  valueKey: 'degree_type_frontend',
                },
                options: [
                ],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'degree_name_other_frontend',
                required: true,
                name: 'degree_name_other_frontend',
                label: 'Degree Name Other',
                type: 'text',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'degree_name_frontend',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'specialization_frontend',
                required: true,
                name: 'specialization_frontend',
                label: 'Specialization',
                type: 'input',
                validationType: 'string',
                rule: {
                  effect: 'HIDE',
                  condition: {
                    unregister: true,
                    scope: 'degree_type_frontend',
                    expectedValue: '10th',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 255,
                    message: 'This field cannot be more than 255 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'board_others_frontend',
                required: true,
                name: 'board_others_frontend',
                label: 'Board Others',
                type: 'input',
                validationType: 'string',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'board_frontend',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'university_name_frontend',
                required: true,
                name: 'university_name_frontend',
                label: 'University/Institution Name',
                type: 'text',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'degree_type_frontend',
                    expectedValue: 'Diploma',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'university_name_frontend',
                required: true,
                name: 'university_name_frontend',
                label: 'University/Institution Name',
                type: 'text',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'degree_type_frontend',
                    expectedValue: 'Bachelor',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'university_name_frontend',
                required: true,
                name: 'university_name_frontend',
                label: 'University/Institution Name',
                type: 'text',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'degree_type_frontend',
                    expectedValue: 'Masters Degree',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'university_name_frontend',
                required: true,
                name: 'university_name_frontend',
                label: 'University/Institution Name',
                type: 'text',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'degree_type_frontend',
                    expectedValue: 'Doctoral Degree',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'university_name_frontend',
                required: true,
                name: 'university_name_frontend',
                label: 'University/Institution Name',
                type: 'text',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'degree_type_frontend',
                    expectedValue: 'Professional Degree (CA/CS/ICWA)',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'university_name_frontend',
                required: true,
                name: 'university_name_frontend',
                label: 'University/Institution Name',
                type: 'text',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'degree_type_frontend',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'university_others_frontend',
                required: true,
                name: 'university_others_frontend',
                label: 'University/Institution Name (Others)',
                type: 'input',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'university_name_frontend',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'year_completion_frontend',
                required: true,
                name: 'year_completion_frontend',
                label: 'Year of Completion',
                type: 'date',
                views: ['year', 'month', 'day'],
                format: 'DD-MMM-YYYY',
                validations: {
                  required: 'This field is required',
                },
                maxDate: true,
                minDate: 50,
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'evaluation_type_frontend',
                required: true,
                name: 'evaluation_type_frontend',
                label: 'Evaluation Type',
                type: 'radio',
                options: [
                  {
                    label: 'CGPA/GPA',
                    value: 'CGPA',
                  },
                  {
                    label: 'Percentage',
                    value: 'Percentage',
                  },
                ],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'max_cgpa_frontend',
                required: true,
                name: 'max_cgpa_frontend',
                label: 'Maximum CGPA/GPA',
                type: 'input',
                validationType: 'numberWithDecimal',
                validateField: {
                  scope: 'obtained_cgpa_frontend',
                  rule: 'GREATER',
                  message: 'Maximum CGPA/GPA should be greater than obtained CGPA/GPA',
                },
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter valid maximum CGPA/GPA',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 10,
                    message: 'This field should not be greater than 10',
                  }
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'evaluation_type_frontend',
                    expectedValue: 'CGPA',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'obtained_cgpa_frontend',
                required: true,
                name: 'obtained_cgpa_frontend',
                label: 'Obtained CGPA/GPA',
                type: 'input',
                validationType: 'numberWithDecimal',
                validateField: {
                  scope: 'max_cgpa_frontend',
                  rule: 'LESSER',
                  message: 'Obtained CGPA/GPA cannot be greater than Maximum CGPA/GPA',
                },
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter valid CGPA/GPA',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 10,
                    message: 'This field should not be greater than 10',
                  }
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'evaluation_type_frontend',
                    expectedValue: 'CGPA',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'equivalent_percentage_frontend',
                required: true,
                name: 'equivalent_percentage_frontend',
                label: 'Obtained Percentage',
                type: 'input',
                validationType: 'numberWithDecimal',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter valid percentage',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 100,
                    message: 'This field should not be greater than 100',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'evaluation_type_frontend',
                    expectedValue: 'Percentage',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },

            ],
          },
        ],
      },
    ],
  },
  {
    stepId: 'workExperience',
    stepName: 'Work Experience',
    showStepName: false,
    stepVisible: true,
    stepPosition: 2,
    stepType: 'form',
    sections: [
      {
        sectionId: 'employmentDetails',
        sectionName: 'Work Experience',
        subSectionName: '',
        sectionPosition: 3,
        summarySection: 'Work Experience',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'workExperiences',
            name: 'workExperiences',
            label: 'Work Experiences',
            type: 'array',
            buttonConfigs: {
              text: 'Add More +',
            },
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 10,
              removeMultiple: true,
              name: 'workExperiences',
              dynamicTitle: 'Work Experience',
            },
            fieldsArray: [
              {
                fieldId: 'Organisation_Name__c',
                name: 'Organisation_Name__c',
                label: 'Company Name',
                type: 'input',
                required: true,
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid company name',
                  },
                  maxLength: {
                    value: 128,
                    message: 'This field cannot be greater than 128 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Industry_Type__c',
                name: 'Industry_Type__c',
                label: 'Industry Type',
                type: 'select',
                required: true,
                options: [
                  { label: 'Information Technology', value: 'Information Technology' },
                  { label: 'Finance & Banking', value: 'Finance & Banking' },
                  { label: 'Healthcare', value: 'Healthcare' },
                  { label: 'Education', value: 'Education' },
                  { label: 'Manufacturing', value: 'Manufacturing' },
                  { label: 'Retail', value: 'Retail' },
                  { label: 'Consulting', value: 'Consulting' },
                  { label: 'Telecommunications', value: 'Telecommunications' },
                  { label: 'Automotive', value: 'Automotive' },
                  { label: 'Real Estate', value: 'Real Estate' },
                  { label: 'Others', value: 'Others' }
                ],
                metaData: {
                  optionsKey: 'industryType',
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Industry_Type_Others__c',
                name: 'Industry_Type_Others__c',
                label: 'Industry Type Others',
                type: 'input',
                required: true,
                options: [],
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 100,
                    message: 'This field cannot be more than 100 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Industry_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Sector__c',
                name: 'Sector__c',
                label: 'Sector',
                type: 'select',
                required: true,
                options: [
                  { label: 'Public', value: 'Public' },
                  { label: 'Private', value: 'Private' },
                  { label: 'Government', value: 'Government' },
                  { label: 'Non-Profit', value: 'Non-Profit' },
                  { label: 'Others', value: 'Others' }
                ],
                metaData: {
                  optionsKey: 'sector',
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Sector_Others__c',
                name: 'Sector_Others__c',
                label: 'Sector Others',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Sector__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Designation__c',
                name: 'Designation__c',
                label: 'Designation',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 128,
                    message: 'This field cannot be more than 128 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Work_Experience_in_Years__c',
                name: 'Work_Experience_in_Years__c',
                label: 'Cumulative Experience(In Years)',
                type: 'select',
                required: true,
                options: [
                  { label: '0-5', value: '0-5' },
                  { label: '5-10', value: '5-10' },
                  { label: '10-15', value: '10-15' },
                  { label: '15+', value: '15+' }
                ],
                metaData: {
                  optionsKey: 'workExperienceLevel',
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Currently_employed__c',
                name: 'Currently_employed__c',
                label: 'Currently Employed?',
                type: 'radio',
                required: true,
                options: [
                  {
                    label: 'Yes',
                    value: true,
                  },
                  {
                    label: 'No',
                    value: false,
                  },
                ],
                validations: {
                  required: 'This field is required',
                  rule: 'SINGLECURRENTEMPLOYMENT',
                  message: 'Only one work experience can be marked as currently employed. Please uncheck other work experiences first.',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Start_Date__c',
                name: 'Start_Date__c',
                label: 'From Date',
                type: 'date',
                format: 'YYYY-MM-DD',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                maxDate: true,
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'End_Date__c',
                name: 'End_Date__c',
                label: 'To Date',
                type: 'date',
                required: true,
                format: 'YYYY-MM-DD',
                validations: {
                  required: 'This field is required',
                },
                minDate: {
                  scope: 'Start_Date__c',
                },
                maxDate: true,
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'Currently_employed__c',
                    expectedValue: 'false',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Brief_Job_Profile__c',
                name: 'Brief_Job_Profile__c',
                label: 'Brief Job Profile',
                type: 'textarea',
                required: true,
                multiline: true,
                rows: 4,
                validations: {
                  required: 'This field is required',
                  minLength: {
                    value: 50,
                    message: 'This field cannot be less than 50 characters',
                  },
                  maxLength: {
                    value: 500,
                    message: 'This field cannot be more than 500 characters',
                  },
                },
                remaining: true,
                maxCharacters: 500,
                ui: {
                  gridType: 'fullRow',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    stepId: 'additionalInformation',
    stepName: 'Additional Information',
    showStepName: false,
    stepVisible: true,
    stepPosition: 3,
    stepType: 'form',
    sections: [
      {
        apiKeyId: 'application',
        sectionId: 'additionalInfo',
        sectionName: 'Additional Information',
        subSectionName: '',
        sectionPosition: 4,
        sectionHelp: 'Fields marked with * are required',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[How_did_you_hear_about_this_program__c]',
            name: 'application[How_did_you_hear_about_this_program__c]',
            label: 'How Did You Hear About This Program?',
            type: 'select',
            required: true,
            options: [
              { label: 'Emailers', value: 'Emailers' },
              { label: 'Facebook', value: 'Facebook' },
              { label: 'IIMU Alumni', value: 'IIMU Alumni' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'LinkedIn', value: 'LinkedIn' },
              { label: 'Print Media', value: 'Print Media' },
              { label: 'Google WebSearch', value: 'Google WebSearch' },
              { label: 'GMAT Club', value: 'GMAT Club' },
              { label: 'Directly visited IIMU Website', value: 'Directly visited IIMU Website' },
              { label: 'Friends/Relatives/Colleagues', value: 'Friends/Relatives/Colleagues' },
              { label: 'WhatsApp', value: 'WhatsApp' },
              { label: 'Newspaper', value: 'Newspaper' },
              { label: 'Company HR', value: 'Company HR' },
              { label: 'Youtube', value: 'Youtube' },
              { label: 'Others', value: 'Others' }
            ],
            metaData: {
              optionsKey: 'hearAboutProgram',
            },
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'application[How_did_you_hear_about_program_others__c]',
            name: 'application[How_did_you_hear_about_program_others__c]',
            label: 'How Did You Hear About This Program(Others)?',
            type: 'input',
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[How_did_you_hear_about_this_program__c]',
                expectedValue: "Others",
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'application[Are_you_an_Alumni_of_IIM_U__c]',
            name: 'application[Are_you_an_Alumni_of_IIM_U__c]',
            label: 'Are you an Alumni of IIM Udaipur or it\'s Long Duration Executive Education Program?',
            type: 'radio',
            required: true,
            options: [
              {
                label: 'Yes',
                value: true,
              },
              {
                label: 'No',
                value: false,
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'application[IIMU_Email_ID__c]',
            name: 'application[IIMU_Email_ID__c]',
            label: 'IIMU Email ID',
            type: 'input',
            required: true,
            validationType: 'email',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Are_you_an_Alumni_of_IIM_U__c]',
                expectedValue: true,
                type: 'LEAF',
              },
            },
            validations: {
              pattern: {
                value: /^[^\s@]+@([^\s@]*\.)?iimu\.ac\.in$/i,
                message: 'Please enter a valid IIMU email address ',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'application[Alumni_Executive_Alumni_ID_Number__c]',
            name: 'application[Alumni_Executive_Alumni_ID_Number__c]',
            label: 'Alumni/Executive Alumni ID Number',
            type: 'input',
            required: true,
            validationType: 'alphanumeric',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Are_you_an_Alumni_of_IIM_U__c]',
                expectedValue: true,
                type: 'LEAF',
              },
            },
            validations: {
              maxLength: {
                value: 50,
                message: 'This field cannot be more than 50 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'application[Expectations_From_The_Program__c]',
            name: 'application[Expectations_From_The_Program__c]',
            label: 'Expectations From The Program',
            type: 'textarea',
            required: false,
            multiline: true,
            rows: 6,
            validations: {
              minLength: {
                value: 20,
                message: 'This field cannot be less than 20 characters',
              },
              maxLength: {
                value: 500,
                message: 'This field cannot be more than 500 characters',
              },
            },
            remaining: true,
            maxCharacters: 500,
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'invoicingDetails',
    stepName: 'Invoicing Information',
    showStepName: false,
    stepVisible: true,
    stepPosition: 4,
    stepType: 'form',
    sections: [
      {
        apiKeyId: 'application',
        sectionId: 'invoicing',
        sectionName: 'Invoicing Details',
        subSectionName: '',
        sectionPosition: 5,
        sectionHelp: 'Fields marked with * are required',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[Bill_to_be_raised_for__c]',
            name: 'application[Bill_to_be_raised_for__c]',
            label: 'Bill to be raised for',
            type: 'radio',
            required: true,
            options: [
              {
                label: 'Self',
                value: 'Self',
              },
              {
                label: 'Sponsor',
                value: 'Sponsor',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Invoice_Participant_Name__c]',
            name: 'application[Invoice_Participant_Name__c]',
            label: 'Name of the Individual',
            type: 'input',
            required: false,
            validationType: 'fullName',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Self',
                type: 'LEAF',
              },
            },
            validations: {
              maxLength: {
                value: 255,
                message: 'This field cannot be more than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Participant_Address__c]',
            name: 'application[Participant_Address__c]',
            label: 'Address of Participant',
            type: 'input',
            required: true,
            rows: 3,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Self',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 500,
                message: 'This field cannot be more than 500 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Invoice_Participant_Email__c]',
            name: 'application[Invoice_Participant_Email__c]',
            label: 'Email ID',
            type: 'input',
            required: false,
            validationType: 'email',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Self',
                type: 'LEAF',
              },
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please enter a valid email address',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Invoice_Participant_Phone__c]',
            name: 'application[Invoice_Participant_Phone__c]',
            label: 'Contact Number',
            type: 'input',
            required: true,
            validationType: 'phone',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Self',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[+0-9]+$/,
                message: 'Accept only numbers and + symbol',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Name_of_the_Sponsor__c]',
            name: 'application[Name_of_the_Sponsor__c]',
            label: 'Name of the Sponsor',
            type: 'input',
            required: true,
            validationType: 'organization',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              maxLength: {
                value: 255,
                message: 'This field cannot be more than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Contact_No_of_the_Sponsor__c]',
            name: 'application[Contact_No_of_the_Sponsor__c]',
            label: 'Contact No. of Sponsor',
            type: 'input',
            required: true,
            validationType: 'phone',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[+0-9]+$/,
                message: 'Accept only numbers and + symbol',
              },
              minLength: {
                value: 10,
                message: 'Phone number must be at least 10 characters',
              },
              maxLength: {
                value: 16,
                message: 'Phone number cannot be more than 16 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[GST_No_of_Sponsor__c]',
            name: 'application[GST_No_of_Sponsor__c]',
            label: 'GST No. of Sponsor',
            type: 'input',
            required: true,
            validationType: 'alphanumeric',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                message: 'Please enter a valid GST number',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[PAN_No_of_Sponsor__c]',
            name: 'application[PAN_No_of_Sponsor__c]',
            label: 'PAN No. of Sponsor',
            type: 'input',
            required: true,
            validationType: 'alphanumeric',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: 'Please enter a valid PAN number',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Sponsor_Address__c]',
            name: 'application[Sponsor_Address__c]',
            label: 'Sponsor Address Line 1',
            type: 'input',
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 255,
                message: 'This field cannot be more than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Sponsor_Address_2__c]',
            name: 'application[Sponsor_Address_2__c]',
            label: 'Sponsor Address Line 2',
            type: 'input',
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 255,
                message: 'This field cannot be more than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Sponsor_Country__c]',
            name: 'application[Sponsor_Country__c]',
            label: 'Country',
            type: 'input',
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Sponsor_State__c]',
            name: 'application[Sponsor_State__c]',
            label: 'State',
            type: 'input',
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Sponsor_City__c]',
            name: 'application[Sponsor_City__c]',
            label: 'City',
            type: 'input',
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Sponsor_Pincode__c]',
            name: 'application[Sponsor_Pincode__c]',
            label: 'Pincode',
            type: 'input',
            required: true,
            validationType: 'number',
            rule: {
              effect: 'SHOW',
              condition: {
                type: 'AND',
                conditions: [
                  {
                    type: 'LEAF',
                    scope: 'application[Bill_to_be_raised_for__c]',
                    expectedValue: ['Sponsor'],
                  },
                  {
                    type: 'LEAF',
                    scope: 'application[Sponsor_Country__c]',
                    expectedValue: ['India'],
                  },
                ],
              },
            },
            validations: {
              required: 'This field is required',
              minLength: {
                value: 6,
                message: 'Please enter a valid Zipcode',
              },
              maxLength: {
                value: 6,
                message: 'Please enter a valid Zipcode',
              },
              pattern: {
                value: '',
                message: 'Please enter a valid Zipcode',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Sponsor_Pincode__c]',
            name: 'application[Sponsor_Pincode__c]',
            label: 'Pincode',
            type: 'input',
            required: true,
            validationType: 'alphaNumeric',
            rule: {
              effect: 'SHOW',
              condition: {
                type: 'AND',
                conditions: [
                  {
                    type: 'LEAF',
                    scope: 'application[Bill_to_be_raised_for__c]',
                    expectedValue: ['Sponsor'],
                  },
                  {
                    type: 'LEAF',
                    scope: 'application[Sponsor_Country__c]',
                    expectedValue: ['India'],
                    not: true,
                  },
                ],
              },
            },
            validations: {
              required: 'This field is required',
              // minLength: {
              //   value: 4,
              //   message: 'This field cannot be less than 4 characters',
              // },
              // maxLength: {
              //   value: 15,
              //   message: 'This field cannot be more than 15 characters',
              // },
              pattern: {
                value: '',
                message: 'Please enter a valid Zipcode',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Invoice_Participant_Name__c]',
            name: 'application[Invoice_Participant_Name__c]',
            label: 'Name of the Participant',
            type: 'input',
            required: true,
            validationType: 'fullName',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 255,
                message: 'This field cannot be more than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Invoice_Participant_Email__c]',
            name: 'application[Invoice_Participant_Email__c]',
            label: 'Email ID',
            type: 'input',
            required: true,
            validationType: 'email',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid email address',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'application[Invoice_Participant_Phone__c]',
            name: 'application[Invoice_Participant_Phone__c]',
            label: 'Contact Number',
            type: 'input',
            required: true,
            validationType: 'phone',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Bill_to_be_raised_for__c]',
                expectedValue: 'Sponsor',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[+0-9]+$/,
                message: 'Accept only numbers and + symbol',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 4,
                lg: 4,
              },
            },
          },
        ],
      },
      // {
      //   apiKeyId: 'addresses',
      //   sectionId: 'address',
      //   sectionName: 'Invoicing Address',
      //   subSectionName: '',
      //   sectionPosition: 3,
      //   sectionHelp: 'Fields marked with * are required',
      //   sectionType: 'form',
      //   sectionVisible: false,
      //   fields: [
      //     {
      //       name: 'addresses[1]',
      //       type: 'address',
      //       options: [
      //         {
      //           fieldId: 'hed__MailingCountry__c',
      //           required: true,
      //           name: 'hed__MailingCountry__c',
      //           isPartOfCollection: true,
      //           label: 'Country',
      //           type: 'select',
      //           validations: {
      //             required: 'This field is required',
      //           },
      //           ui: {
      //             grid: {
      //               xs: 12,
      //               md: 6,
      //               lg: 4,
      //             },
      //           },
      //         },
      //         {
      //           fieldId: 'hed__MailingState__c',
      //           required: true,
      //           name: 'hed__MailingState__c',
      //           label: 'State',
      //           type: 'select',
      //           validations: {
      //             required: 'This field is required',
      //           },
      //           options: [],
      //           ui: {
      //             grid: {
      //               xs: 12,
      //               md: 6,
      //               lg: 4,
      //             },
      //           },
      //         },
      //         {
      //           fieldId: 'hed__MailingCity__c',
      //           required: true,
      //           name: 'hed__MailingCity__c',
      //           label: 'City',
      //           type: 'select',
      //           validations: {
      //             required: 'This field is required',
      //           },
      //           options: [],
      //           ui: {
      //             grid: {
      //               xs: 12,
      //               md: 6,
      //               lg: 4,
      //             },
      //           },
      //         },
      //       ],
      //     },
      //     {
      //       fieldId: 'addresses[0][hed__MailingStreet__c]',
      //       required: true,
      //       name: 'addresses[0][hed__MailingStreet__c]',
      //       label: 'Address Line 1',
      //       type: 'input',
      //       validations: {
      //         required: 'This field is required',
      //         maxLength: {
      //           value: 254,
      //           message: 'This field cannot be more than 254 characters',
      //         },
      //       },
      //       ui: {
      //         grid: {
      //           xs: 12,
      //           md: 6,
      //           lg: 4,
      //         },
      //       },
      //     },
      //     {
      //       fieldId: 'addresses[0][hed__MailingStreet2__c]',
      //       required: true,
      //       name: 'addresses[0][hed__MailingStreet2__c]',
      //       label: 'Address Line 2',
      //       type: 'input',
      //       validations: {
      //         required: 'This field is required',
      //         maxLength: {
      //           value: 254,
      //           message: 'This field cannot be more than 254 characters',
      //         },
      //       },
      //       ui: {
      //         grid: {
      //           xs: 12,
      //           md: 6,
      //           lg: 4,
      //         },
      //       },
      //     },
      //     {
      //       fieldId: 'addresses[0][hed__MailingPostalCode__c]',
      //       required: true,
      //       name: 'addresses[0][hed__MailingPostalCode__c]',
      //       label: 'Pincode',
      //       type: 'input',
      //       validationType: 'number',
      //       validations: {
      //         required: 'This field is required',
      //         "minLength": {
      //           "value": 6,
      //           "message": "Please enter a valid Zipcode"
      //         },
      //         "maxLength": {
      //           "value": 6,
      //           "message": "Please enter a valid Zipcode"
      //         },
      //         "pattern": {
      //           "value": "",
      //           "message": "Please enter a valid Zipcode"
      //         }
      //       },
      //       "rule": {
      //         "effect": "SHOW",
      //         "condition": {
      //           "scope": "addresses[0][hed__MailingCountry__c]",
      //           "expectedValue": "India",
      //           "type": "LEAF"
      //         }
      //       },
      //       ui: {
      //         grid: {
      //           xs: 12,
      //           md: 6,
      //           lg: 4,
      //         },
      //       },
      //     },
      //     {
      //       fieldId: 'addresses[0][hed__MailingPostalCode__c]',
      //       required: true,
      //       name: 'addresses[0][hed__MailingPostalCode__c]',
      //       label: 'Pincode',
      //       type: 'input',
      //       validationType: 'number',
      //       validations: {
      //         required: 'This field is required',
      //         "minLength": {
      //           "value": 4,
      //           "message": "This field cannot be less than 4 characters"
      //         },
      //         "maxLength": {
      //           "value": 10,
      //           "message": "This field cannot be more than 10 characters"
      //         },
      //         "pattern": {
      //           "value": "",
      //           "message": "Please enter a valid Zipcode"
      //         }
      //       },
      //       "rule": {
      //         "effect": "HIDE",
      //         "condition": {
      //           "scope": "addresses[0][hed__MailingCountry__c]",
      //           "expectedValue": "India",
      //           "type": "LEAF"
      //         }
      //       },
      //       ui: {
      //         grid: {
      //           xs: 12,
      //           md: 6,
      //           lg: 4,
      //         },
      //       },
      //     },
      //   ],
      // },
    ],
  },
  {
    stepId: 'summaryWithDeclaration',
    stepName: 'Summary',
    stepPosition: 5,
    showStepName: true,
    stepVisible: true,
    stepType: 'summary',
    voucher: true,
    sections: [],
  },
  {
    stepId: 'declaration',
    stepName: 'Declaration',
    stepPosition: 6,
    showStepName: true,
    stepVisible: true,
    stepType: 'declaration',
    voucher: true,
    sections: [],
  },
];